var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-pub-pop"},[_c('PublicForm',{attrs:{"width":'100px',"formData":_vm.formData,"formList":_vm.cols}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }